import tutorialModelAIcon from "url:shared-assets/images/tutorialModelImages/tutorialModelE.svg";
import { useTranslation } from 'react-i18next';

const ModelE = (prop: any) => {
    const translation = useTranslation();
    const { t } = translation;
    const { currentStepNumber, totalSteps } = prop;
    return (
        <div className="z-modal-content-height">
            <div className="flex flex-col items-center gap-4">
                <img className="w-60 h-60" src={tutorialModelAIcon} alt="tutorialModelE" /></div>
            <div className="space-y-4 w-full h-54">
                <p className="z-title5">{t("step")} {currentStepNumber} {t("of")} {totalSteps}</p>
                <div className="z-heading2 gray-100">{t("modelE-title")}</div>
                <div className="space-y-4">
                    <p className="z-body1">{t("modelE-description")}</p>
                    <p className="z-body1">{t("modelE-description-extended")}</p>
                </div>

            </div>
        </div>
    );
};

export default ModelE;